import React, { Fragment, useEffect, useState } from 'react';
import { Divider, Loader, Modal } from 'semantic-ui-react';
import './InvoiceCard.scss';
import Card from './elements/Card/Card';
import { client } from '../../../shared/client';
import { url } from '../../../shared/URL';

const filterEmptyStrings = (arr) => {
  return (arr || []).filter((item) => item !== '');
};

const extractDetail = (response) => {
  const payload = response && response.data && response.data.payload;
  if (!payload) {
    return null;
  }
  if (payload.data && !Array.isArray(payload.data)) {
    return payload.data;
  }
  if (Array.isArray(payload.data) && payload.data.length) {
    return payload.data[0];
  }
  if (Array.isArray(payload.content) && payload.content.length) {
    return payload.content[0];
  }
  return payload;
};

const InvoiceCard = ({ content, update, close }) => {
  const [open] = useState<boolean>(true);
  const [detail, setDetail] = useState(content);
  const [loadingDetail, setLoadingDetail] = useState(false);

  useEffect(() => {
    const id = content && (content.id || content.invoiceId);
    const hasImages =
      (content &&
        content.imageUrlSeller &&
        content.imageUrlSeller.length > 0) ||
      (content && content.imageUrlBuyer && content.imageUrlBuyer.length > 0);

    if (!id || hasImages) {
      setDetail(content);
      return;
    }

    setLoadingDetail(true);
    client
      .post(`${url.invoiceById}${id}`, {
        offset: 0,
        size: 1,
        sortBy: 'id',
        sortDirection: 'asc',
      })
      .then((response) => {
        const data = extractDetail(response);
        if (data) {
          setDetail({ ...content, ...data });
        }
      })
      .catch(() => {
        setDetail(content);
      })
      .finally(() => setLoadingDetail(false));
  }, [content]);

  const sellerImages = filterEmptyStrings(detail && detail.imageUrlSeller);
  const buyerImages = filterEmptyStrings(detail && detail.imageUrlBuyer);

  return (
    <>
      <Modal open={open} onClose={close} closeIcon className="details-modal">
        <Modal.Header>{`${detail.upd || content.upd} от ${
          detail.dateTime || content.dateTime
        }`}</Modal.Header>
        <Modal.Content className="details-modal__content">
          {loadingDetail ? (
            <Loader active inline="centered" />
          ) : (
            <div className="invoices">
              <h3>Прикрепленные документы покупателя</h3>
              {buyerImages.length > 0 ? (
                buyerImages.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <Card item={item} />
                    </Fragment>
                  );
                })
              ) : (
                <h3>Нет загруженных документов</h3>
              )}
              <Divider />
              <h3>Прикрепленные документы продавца</h3>
              {sellerImages.length > 0 ? (
                sellerImages.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <Card item={item} />
                    </Fragment>
                  );
                })
              ) : (
                <h3>Нет загруженных документов</h3>
              )}
            </div>
          )}
        </Modal.Content>
      </Modal>
    </>
  );
};

export default InvoiceCard;
